import { getLiveTagValue } from "@/features/datapoints/api/getLiveTagValue.ts"

import type { FlowRateDisplayData } from "../../types/flowRateDisplayTypes.ts"

export const getFlowRateDisplayData = async (): Promise<FlowRateDisplayData> => {
  const values = await Promise.all([
    getLiveTagValue("LWRN_MainPLC/Analog/SCFM_TREATMENT_FE_101"),
    getLiveTagValue("LWRN_MainPLC/Analog/GA_101_METHANE_PERCENT"),
    getLiveTagValue("LWRN_MainPLC/Analog/SCFM_PIPELINE_FE_1000"),
    getLiveTagValue("LWRN_MainPLC/Analog/GA_1000_METHANE_PERCENT"),
    getLiveTagValue("default/BCO/Live/Plant Status"),
  ])

  return {
    inletSCFM: values[0],
    inletCH4: values[1],
    outletSCFM: values[2],
    outletCH4: values[3],
    online: values[2] > 0,
  }
}
